import {
  ECatalogItemIdentifierType,
  TDestinationCredentials,
} from '@/core/apis/config_api/config_api_types';
import { TMableProduct } from '@/core/constants/event_types/extended_mable_event';

export const DestEventBuilder = {
  getProductCatalogItemIdForMableProduct(
    mableProduct: TMableProduct | undefined,
    destinationConfig: TDestinationCredentials,
  ): string {
    if (!mableProduct) {
      return '';
    }
    const identifierType = destinationConfig?.catalog_item_identifier_type;
    const mableProductIds = mableProduct?.ids;
    // Map the identifier type to the corresponding product field
    switch (identifierType) {
      case ECatalogItemIdentifierType.VARIANT_ID: {
        return (
          mableProductIds?.vid ||
          mableProductIds?.pid ||
          mableProductIds?.sku ||
          ''
        );
      }
      case ECatalogItemIdentifierType.PRODUCT_ID: {
        return (
          mableProductIds?.pid ||
          mableProductIds?.vid ||
          mableProductIds?.sku ||
          ''
        );
      }
      case ECatalogItemIdentifierType.SKU: {
        return (
          mableProductIds?.sku ||
          mableProductIds?.pid ||
          mableProductIds?.vid ||
          ''
        );
      }
      default: {
        return (
          mableProductIds?.pid ||
          mableProductIds?.vid ||
          mableProductIds?.sku ||
          ''
        );
      }
    }
  },
};
